import { Injectable } from '@angular/core'
import { environment } from '@candidate/environments/environment'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  DEFAULT_NETWORK_MONITORING_CONFIG,
  getBaseSuffix,
  ICandidateJobSubmission,
  ICandidateJobSubmissionPreview,
  IProcessedJobApplication,
  IProcessedJobApplicationV2,
  TokenStorage,
} from 'shared-lib'
import { CandidateApplicationService } from '../candidate-application/candidate-application.service'

interface IWithdrawApplicationArgs {
  jobPostId: string
  candidateId: string
  reason: string
}
@Injectable({
  providedIn: 'root',
})
export class JobApplicationService {
  private restAPIClient: RestApiClient
  constructor(tokenStorage: TokenStorage, private candidateApplicationService: CandidateApplicationService) {
    this.restAPIClient = new RestApiClient({
      baseUrl: environment.services.jobs,
      token: () => tokenStorage.getAccessToken(),
      throwNon200s: true,
      baseSuffix: getBaseSuffix(environment, 'jobs'),
      ...DEFAULT_NETWORK_MONITORING_CONFIG,
    })
  }

  submitApplication(applicationInformation: ICandidateJobSubmission): Observable<IProcessedJobApplicationV2> {
    return this.restAPIClient
      .post<IProcessedJobApplicationV2>('processed-job-application', applicationInformation, { version: '2' })
      .pipe(map(item => item.data))
  }

  previewApplication(previewInformation: ICandidateJobSubmissionPreview): Observable<IProcessedJobApplication> {
    return this.restAPIClient.post('processed-job-application/preview', previewInformation).pipe(map(item => item.data))
  }

  withdrawApplication(args: IWithdrawApplicationArgs) {
    const { jobPostId, candidateId, reason } = args
    const applicationId = this.candidateApplicationService.buildJobApplicationId(jobPostId, candidateId)
    return this.restAPIClient.put(`candidate-job-application/${applicationId}/withdraw`, { reason })
  }

  undoWithdrawal(jobPostId: string, candidateId: string) {
    const applicationId = this.candidateApplicationService.buildJobApplicationId(jobPostId, candidateId)
    return this.restAPIClient.put(`candidate-job-application/${applicationId}/undo-withdrawal`, {}).pipe(map(res => res.data))
  }
}
